export const equipmentKeys = {
  all: ['equipments'] as const,
  lists: () => [...equipmentKeys.all, 'list'] as const,
  list: (orgId?: string) => [...equipmentKeys.lists(), orgId ?? 'all'] as const,
  details: () => [...equipmentKeys.all, 'detail'] as const,
  detail: (id: string) => [...equipmentKeys.details(), id] as const,
  bySite: (siteId: string) => [...equipmentKeys.all, 'bySite', siteId] as const,
  interventionCount: (id: string) =>
    [...equipmentKeys.all, 'interventionCount', id] as const,
}
